"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Types = _interopRequireDefault(require("../../types/Types"));

var _ActionCreators = _interopRequireDefault(require("../../change/ActionCreators"));

var _default = function _default(_this) {
  return {
    insertAfter: function insertAfter(key, value) {
      (0, _Types.default)("insertAfter()", "key", "keyIndex")(key);

      _this.dispatch(_ActionCreators.default.insertAfter(key, value));
    },
    insertBefore: function insertBefore(key, value) {
      (0, _Types.default)("insertBefore()", "key", "keyIndex")(key);

      _this.dispatch(_ActionCreators.default.insertBefore(key, value));
    },
    move: function move(keyA, keyB) {
      (0, _Types.default)("move()", "keyA", "keyIndex")(keyA);
      (0, _Types.default)("move()", "keyB", "keyIndex")(keyB);

      _this.dispatch(_ActionCreators.default.move(keyA, keyB));
    },
    push: function push() {
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }

      _this.dispatch(_ActionCreators.default.push(values));
    },
    pop: function pop() {
      _this.dispatch(_ActionCreators.default.pop());
    },
    shift: function shift() {
      _this.dispatch(_ActionCreators.default.shift());
    },
    swap: function swap(keyA, keyB) {
      (0, _Types.default)("swap()", "keyA", "keyIndex")(keyA);
      (0, _Types.default)("swap()", "keyB", "keyIndex")(keyB);

      _this.dispatch(_ActionCreators.default.swap(keyA, keyB));
    },
    swapNext: function swapNext(key) {
      (0, _Types.default)("swapNext()", "key", "keyIndex")(key);

      _this.dispatch(_ActionCreators.default.swapNext(key));
    },
    swapPrev: function swapPrev(key) {
      (0, _Types.default)("swapPrev()", "key", "keyIndex")(key);

      _this.dispatch(_ActionCreators.default.swapPrev(key));
    },
    unshift: function unshift() {
      for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        values[_key2] = arguments[_key2];
      }

      _this.dispatch(_ActionCreators.default.unshift(values));
    }
  };
};

exports.default = _default;